import React, { useEffect, useState } from "react";
import api from "../../services/axiosInstance";

const AcademicCourses = () => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAcademic = async () => {
    try {
      const { data } = await api.get("/free-courses"); 
      setYears(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAcademic();
  }, []);

  if (loading) return <div className="p-10">Chargement...</div>;

  return (
    <div className="min-h-screen mt-8 bg-gray-50 p-10">
      <h1 className="text-3xl font-bold mb-8">
        Ressources Académiques
      </h1>

      <div className="grid md:grid-cols-3 gap-6">
        {years.map((year, index) => (
          <div
            key={index}
            onClick={() => window.open(year.fileLink, "_blank")}
            className="cursor-pointer p-6 rounded-xl bg-white shadow-md hover:shadow-xl transition"
          >
            <h2 className="text-xl font-bold mb-2">{year.year}</h2>
            <p className="text-gray-500">Accéder aux cours</p>

            <div className="mt-4 text-sm text-green-600 font-semibold">
              Gratuit ✅
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AcademicCourses;